import { render, staticRenderFns } from "./33.vue?vue&type=template&id=f0f1a2b6&scoped=true&"
var script = {}
import style0 from "./33.vue?vue&type=style&index=0&id=f0f1a2b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0f1a2b6",
  null
  
)

export default component.exports